<p-dialog
  #orgSelector
  [(visible)]="selectorVisible"
  [blockScroll]="true"
  [closable]="true"
  [closeOnEscape]="false"
  [style]="{ width: '350px', height: '460px' }"
  [contentStyle]="{ height: '100%', 'padding-top': 0 }"
  [modal]="true"
  [responsive]="true"
  [draggable]="true"
>
  <p-header>
    <span
      style="
        font-weight: bold;
        display: inline-block;
        padding-left: 8px;
        font-size: 14px;
        line-height: 22px;
        margin-top: 8px;
      "
    >
      Select the Organisation or a Specific User
    </span>
  </p-header>

  <div *ngIf="organisation" style="color: rgb(51, 51, 51); flex-grow: 1; font-size: 14px">
    <div class="px-2" style="margin-top: 5px">
      <!-- Organisation selection -->
      <div
        class="select-box"
        [ngClass]="{ 'select-box-selected': !this.selectedUser }"
        tabindex="0"
        (click)="orgSelected()"
      >
        {{ organisation.name }}
      </div>

      <div class="separator">
        <hr class="line" />
        <span class="text">or</span>
        <hr class="line" />
      </div>

      <!-- User selection -->
      <div>
        <div class="md-inputfield" style="position: relative; margin-bottom: 3px">
          <input
            id="nameInput"
            #nameInput
            autofocus
            (ngModelChange)="searchTextChanged($event)"
            [ngModel]="searchText"
            autocomplete="off"
            class="search-box"
            name="nameInput"
            pInputText
            placeholder="Search User"
            spellcheck="false"
            type="text"
            style="width: 100%"
          />
          <span class="fa fa-search search-icon"></span>
        </div>

        <div style="overflow-y: auto; max-height: 196px">
          <div *ngFor="let user of filteredUsers; let i = index">
            <div
              class="select-box"
              [ngClass]="{ 'select-box-selected': this.selectedUser == user }"
              [tabIndex]="i + 1"
              (click)="userSelected(user)"
            >
              {{ user.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <button
      [disabled]="!selectedUser && !organisation"
      pButton
      label="Confirm"
      (click)="confirmSelection()"
    ></button>
  </p-footer>
</p-dialog>
